// extracted by mini-css-extract-plugin
export default {"wrap":"kG-z","logoContainer":"lG-z","brandImg":"mG-z","logoImg":"nG-z","logoButton":"oG-z"};